import { render, staticRenderFns } from "./SiestaTunein.vue?vue&type=template&id=95186342&scoped=true&"
import script from "./SiestaTunein.vue?vue&type=script&lang=js&"
export * from "./SiestaTunein.vue?vue&type=script&lang=js&"
import style0 from "./SiestaTunein.vue?vue&type=style&index=0&id=95186342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95186342",
  null
  
)

export default component.exports